var Marionette = require('marionette');
var Behaviors = require('Behaviors');

var View = Marionette.View.extend({
    behaviors: [{ behaviorClass: Behaviors.Tooltip }, Behaviors.PrintCheckbox, Behaviors.MobileView],
    events: {
        'click @ui.restricted': function (e) { this.model.set('restricted', e.target.checked); },
        'click @ui.restrictedQuestion': function (e) { e.preventDefault(); }
    },
    template: '#recordRestricted',
    ui: {
        restricted: '#restricted',
        icon: '#restrictedIcon',
        restrictedQuestion:'#restrictedQuestion'
    },
    onRender: function () {
        //this.ui.icon.tooltip();
        this.ui.restricted.attr("checked", this.model.get('restricted'));
    }
});

module.exports.start = function (options) {
    var region = options.region;
    var record = options.record;

    region.show(new View({ model: record }));
};


// WEBPACK FOOTER //
// ./js/Modules/Record/UI/RecordRestricted.js